import ReactMarkdown from "react-markdown"

export const PlainLanguageSection = ({ markdown }: { markdown: string }) =>
  markdown.trim() ? (
    <div className="flex h-full w-full min-h-0 flex-col">
      <div className="flex-1 min-h-0 w-full overflow-auto rounded-lg border border-slate-200/70 bg-slate-50/70 px-4 py-3 text-slate-700">
        <div className="prose prose-slate react-markdown max-w-none text-sm">
          <ReactMarkdown>{markdown}</ReactMarkdown>
        </div>
      </div>
    </div>
  ) : (
    <p className="text-sm text-muted-foreground">Build your license to see a plain language summary here.</p>
  )
